import React, { useState, useCallback } from 'react';
import { Typography, Button } from 'ui-kit';
import { message } from 'antd';
import _ from 'lodash';

import { useLoadingBackdrop } from 'hooks/useLoadingBackdrop';
import { setStoreVisibility } from 'api/store_sdk';
import ConfirmModal from 'components/ConfirmModal';

import './StoreListItem.scss';

interface IActiveStore {
  isActive: boolean;
  storeId: number;
  storeName: string;
  onUpdate: () => void;
  inSideBar?: boolean;
}

const ActiveStore = ({
  isActive,
  storeId,
  storeName,
  onUpdate,
  inSideBar = false,
}: IActiveStore) => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(isActive);
  const [showLoading, hideLoading] = useLoadingBackdrop();

  const handleChangeVisibility = useCallback(() => {
    showLoading();
    setStoreVisibility({ storeId, isVisible: !active })
      .then(() => {
        setIsOpen(false);
        setActive(!active);
        message.success(`Store successfully set to ${active ? 'inactive' : 'active'}`);
        onUpdate();
        hideLoading();
      })
      .catch((error) => {
        setIsOpen(false);
        setActive(active);
        message.error(error.message || 'Something went wrong! Please try again later');
        hideLoading();
      });
  }, [showLoading, hideLoading, active, storeId, storeName, onUpdate]);

  return (
    <>
      <Button
        className={`store-link ${inSideBar ? 'in-side-bar' : ''}`}
        color="textLight"
        onClick={() => setIsOpen(true)}
      >
        Set store to {active ? 'inactive' : 'active'}
      </Button>
      <ConfirmModal
        className="ConfirmPropagateModal"
        visible={isOpen}
        onConfirm={handleChangeVisibility}
        onCancel={() => setIsOpen(false)}
        confirmText="Confirm"
        cancelText="Cancel"
        confirmBtnType="error"
        destroyOnClose
      >
        {active ? (
          <>
            <Typography variant="h6">
              Do you want to make {storeName} <strong>inactive</strong> for your guests?
            </Typography>
            <Typography variant="body2">
              You still will be able to update the store from your dashboard.
            </Typography>
          </>
        ) : (
          <Typography variant="h6">
            Do you want you make {storeName} <strong>active</strong> for your guests?
          </Typography>
        )}
      </ConfirmModal>
    </>
  );
};

export default ActiveStore;
